
import { defaultFontSetting,  defaultPaddingSetting, defaultBorderRadiusSetting, defaultBoxShadowSetting, defaultIconSetting, defaultComplexFontSetting } from '../setting/defaultSetting'
export const props = [
  {
    name: "secondNavTitle",
    desc: "标题",
    isSystem: true,
    group: "默认",
    categoryName: "二级导航",
    type: "complexFontSet",
    defaultValue: {
      ...defaultComplexFontSetting,
      fontSize: 15,
      fontWeight: 600
    }
  },
  {
    name: "secondNavActiveTitle",
    desc: "标题",
    isSystem: true,
    group: "选中",
    categoryName: "二级导航",
    type: "complexFontSet",
    defaultValue: {
      ...defaultComplexFontSetting,
    }
  },
  {
    name: "secondActiveNavTitleBackground",
    desc: "背景",
    isSystem: true,
    group: "选中",
    categoryName: "二级导航",
    type: "backgroundSet",
    defaultValue: [{
      type: "color",
      color: "rgba(255, 255, 255, 0)",
      isThemeColor: false
    }]
  },
  {
    name: "secondNavTitleActiveBorder",
    desc: "边框",
    isSystem: true,
    group: "选中",
    type: "borderSet",
    categoryName: "二级导航",
    defaultValue: {
      borderStyle: "solid",
      borderWidth: [0, 0, 0, 0],
      borderColor: "rgba(10, 107, 255, 1)"
    }
  },
  {
    name: "secondNavHoverTitle",
    desc: "标题",
    isSystem: true,
    group: "悬浮",
    categoryName: "二级导航",
    type: "complexFontSet",
    defaultValue: {
      ...defaultComplexFontSetting,
    }
  },
  {
    name: "secondHoverNavTitleBackground",
    desc: "背景",
    isSystem: true,
    group: "悬浮",
    categoryName: "二级导航",
    type: "backgroundSet",
    defaultValue: [{
      type: "color",
      color: "rgba(255, 255, 255, 0)",
      isThemeColor: false
    }]
  },
  {
    name: "secondNavTitleHoverBorder",
    desc: "边框",
    isSystem: true,
    group: "悬浮",
    type: "borderSet",
    categoryName: "二级导航",
    defaultValue: {
      borderStyle: "solid",
      borderWidth: [0, 0, 0, 0],
      borderColor: "rgba(10, 107, 255, 1)"
    }
  },
  {
    name: "secondNavIcon",
    desc: "图标",
    isSystem: true,
    group: "默认",
    categoryName: "二级导航",
    type: "iconSet",
    defaultValue: {
      ...defaultIconSetting,
    }
  },
  {
    name: "secondNavHoverIcon",
    desc: "图标",
    isSystem: true,
    group: "默认",
    categoryName: "二级导航",
    type: "iconSet",
    defaultValue: {
      ...defaultIconSetting,
    }
  },
  {
    name: "secondNavTitleBackground",
    desc: "背景",
    isSystem: true,
    group: "默认",
    categoryName: "二级导航",
    type: "backgroundSet",
    defaultValue: [{
      type: "color",
      color: "rgba(255, 255, 255, 0)",
      isThemeColor: false
    }]
  },
  {
    name: "showSecondNavBorder",
    desc: "显示边框",
    isSystem: true,
    group: "默认",
    type: "booleanSet",
    categoryName: "二级导航",
    defaultValue: false
  },
  {
    name: "showSecondNavActiveBorder",
    desc: "显示边框",
    isSystem: true,
    group: "选中",
    type: "booleanSet",
    categoryName: "二级导航",
    defaultValue: false
  },
  {
    name: "showSecondNavHoverBorder",
    desc: "显示边框",
    isSystem: true,
    group: "悬浮",
    type: "booleanSet",
    categoryName: "二级导航",
    defaultValue: false
  },
  {
    name: "secondNavTitleBorder",
    desc: "标题边框",
    isSystem: true,
    group: "默认",
    type: "borderSet",
    categoryName: "二级导航",
    defaultValue: {
      borderStyle: "solid",
      borderWidth: [0, 0, 0, 0],
      borderColor: "rgba(10, 107, 255, 1)"
    }
  },
  {
    name: "secondNavPadding",
    desc: "边距",
    isSystem: true,
    group: "默认",
    type: "paddingSet",
    categoryName: "二级导航",
    defaultValue: {
      ...defaultPaddingSetting,
      paddingTypeFlag: 2,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0
    }
  },
  {
    name: "secondRadius",
    desc: "圆角",
    isSystem: true,
    group: "默认",
    categoryName: "二级导航",
    type: "radiusSet",
    defaultValue: {
      ...defaultBorderRadiusSetting,
    }
  },
  {
    name: "secondNavActivePadding",
    desc: "边距",
    isSystem: true,
    group: "选中",
    type: "paddingSet",
    categoryName: "二级导航",
    defaultValue: {
      ...defaultPaddingSetting,
      paddingTypeFlag: 2,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0
    }
  },
  {
    name: "secondNavHoverPadding",
    desc: "边距",
    isSystem: true,
    group: "悬浮",
    type: "paddingSet",
    categoryName: "二级导航",
    defaultValue: {
      ...defaultPaddingSetting,
      paddingTypeFlag: 2,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0
    }
  },
  {
    name: "secondNavBorderRadius",
    desc: "圆角",
    isSystem: true,
    group: "默认",
    categoryName: "二级导航",
    type: "radiusSet",
    defaultValue: {
      ...defaultBorderRadiusSetting,
    }
  },
  {
    name: "secondActiveRadius",
    desc: "圆角",
    isSystem: true,
    group: "选中",
    categoryName: "二级导航",
    type: "radiusSet",
    defaultValue: {
      ...defaultBorderRadiusSetting,
    }
  },
  {
    name: "secondHoverRadius",
    desc: "圆角",
    isSystem: true,
    group: "悬浮",
    categoryName: "二级导航",
    type: "radiusSet",
    defaultValue: {
      ...defaultBorderRadiusSetting,
    }
  },
  {
    name: "thirdNavTitleMargin",
    desc: "间距",
    isSystem: true,
    type: "marginSet",
    group: "默认",
    categoryName: "三级导航",
    defaultValue: {
      leftMargin: 10,
      topMargin: 10
    }
  },
  {
    name: "thirdNavTitle",
    desc: "文字",
    isSystem: true,
    type: "complexFontSet",
    group: "默认",
    categoryName: "三级导航",
    defaultValue: {
      ...defaultComplexFontSetting,
      fontSize: 14,
      lineHeight: 40,
      fontWeight: 400,
    }
  },
  {
    name: "thirdNavHoverTitle",
    desc: "文字",
    isSystem: true,
    type: "complexFontSet",
    group: "默认",
    categoryName: "三级导航",
    defaultValue: {
      ...defaultComplexFontSetting,
      fontSize: 13,
      lineHeight: 40,
      fontWeight: 400,
    }
  },
  {
    name: "thirdNavPadding",
    desc: "边距",
    isSystem: true,
    type: "paddingSet",
    group: "默认",
    categoryName: "三级导航",
    defaultValue: {
      ...defaultPaddingSetting,
    }
  },
  {
    name: "thirdNavActivePadding",
    desc: "边距",
    isSystem: true,
    type: "paddingSet",
    group: "选中",
    categoryName: "三级导航",
    defaultValue: {
      ...defaultPaddingSetting,
    }
  },
  {
    name: "thirdNavHoverPadding",
    desc: "边距",
    isSystem: true,
    type: "paddingSet",
    group: "悬停",
    categoryName: "三级导航",
    defaultValue: {
      ...defaultPaddingSetting,
    }
  },
  {
    name: "thirdNavColumns",
    desc: "每行列数",
    isSystem: true,
    type: "numberSet",
    group: "默认",
    categoryName: "三级导航",
    defaultValue: 10
  },
  {
    name: "thirdNavShowMore",
    desc: "超出显示更多",
    isSystem: true,
    type: "booleanSet",
    group: "默认",
    categoryName: "三级导航",
    defaultValue: true
  },
  {
    name: "thirdActiveNavTitle",
    desc: "标题",
    isSystem: true,
    group: "选中",
    categoryName: "三级导航",
    type: "complexFontSet",
    defaultValue: {
      ...defaultComplexFontSetting,
      fontSize: 14,
      fontWeight: 400,
      fontColor: "rgba(10, 107, 255, 1)"
    }
  },
  {
    name: "thirdHoverNavTitle",
    desc: "标题",
    isSystem: true,
    group: "悬浮",
    categoryName: "三级导航",
    type: "complexFontSet",
    defaultValue: {
      ...defaultComplexFontSetting,
      fontSize: 14,
      fontWeight: 400,
      fontColor: "rgba(10, 107, 255, 1)"
    }
  },
  {
    name: "thirdRadius",
    desc: "圆角",
    isSystem: true,
    group: "默认",
    categoryName: "三级导航",
    type: "radiusSet",
    defaultValue: {
      ...defaultBorderRadiusSetting,
    }
  },
  {
    name: "thirdActiveRadius",
    desc: "圆角",
    isSystem: true,
    group: "选中",
    categoryName: "三级导航",
    type: "radiusSet",
    defaultValue: {
      ...defaultBorderRadiusSetting,
    }
  },
  {
    name: "thirdHoverRadius",
    desc: "圆角",
    isSystem: true,
    group: "悬浮",
    categoryName: "三级导航",
    type: "radiusSet",
    defaultValue: {
      ...defaultBorderRadiusSetting,
    }
  },
  {
    name: "showThirdBorder",
    desc: "显示边框",
    isSystem: true,
    group: "默认",
    type: "booleanSet",
    categoryName: "三级导航",
    defaultValue: false
  },
  {
    name: "showThirdActiveBorder",
    desc: "显示边框",
    isSystem: true,
    group: "选中",
    type: "booleanSet",
    categoryName: "三级导航",
    defaultValue: false
  },
  {
    name: "showThirdHoverBorder",
    desc: "显示边框",
    isSystem: true,
    group: "悬浮",
    type: "booleanSet",
    categoryName: "三级导航",
    defaultValue: false
  },
  {
    name: "thirdTitleBorder",
    desc: "边框",
    isSystem: true,
    group: "默认",
    type: "borderSet",
    categoryName: "三级导航",
    defaultValue: {
      borderStyle: "solid",
      borderWidth: [0, 0, 0, 0],
      borderColor: "rgba(10, 107, 255, 1)"
    }
  },
  {
    name: "thirdTitleActiveBorder",
    desc: "边框",
    isSystem: true,
    group: "选中",
    type: "borderSet",
    categoryName: "三级导航",
    defaultValue: {
      borderStyle: "solid",
      borderWidth: [0, 0, 0, 0],
      borderColor: "rgba(10, 107, 255, 1)"
    }
  },
  {
    name: "thirdTitleHoverBorder",
    desc: "边框",
    isSystem: true,
    group: "悬浮",
    type: "borderSet",
    categoryName: "三级导航",
    defaultValue: {
      borderStyle: "solid",
      borderWidth: [0, 0, 0, 0],
      borderColor: "rgba(10, 107, 255, 1)"
    }
  },
  {
    name: "thirdNavTitleBackground",
    desc: "标题背景",
    isSystem: true,
    group: "默认",
    categoryName: "三级导航",
    type: "backgroundSet",
    defaultValue: [{
      type: "color",
      color: "rgba(255, 255, 255, 0)",
      isThemeColor: false
    }]
  },
  {
    name: "thirdActiveNavTitleBackground",
    desc: "标题背景",
    isSystem: true,
    group: "选中",
    categoryName: "三级导航",
    type: "backgroundSet",
    defaultValue: [{
      type: "color",
      color: "rgba(255, 255, 255, 0)",
      isThemeColor: false
    }]
  },
  {
    name: "thirdHoverNavTitleBackground",
    desc: "标题背景",
    isSystem: true,
    group: "悬浮",
    categoryName: "三级导航",
    type: "backgroundSet",
    defaultValue: [{
      type: "color",
      color: "rgba(255, 255, 255, 0)",
      isThemeColor: false
    }]
  },
  {
    name: "ulWidthType",
    desc: "宽度",
    group: "默认",
    categoryName: "菜单列表",
    type: "sliderSet",
    extraConfig: {
      options: [{
        title: '充满页面',
        value: 'fullPage'
      }, {
        title: '跟随版心',
        value: 'withCenter'
      }]
    },
    defaultValue: 'withCenter'
  },
  {
    name: "ulMargin",
    desc: "左右边距",
    group: "默认",
    categoryName: "菜单列表",
    type: "numberSet",
    unit: 'px',
    defaultValue: 0,
    extraConfig: {
      suffix: 'px',
      sliderMax: 5000
    }
  },
  {
    name: "navSite",
    desc: "位置",
    group: "默认",
    categoryName: "菜单列表",
    type: "cxSite",
    defaultValue: {
      alignmentType: "center"
    }
  },
  {
    name: "navSize",
    desc: "尺寸",
    group: "默认",
    categoryName: "菜单列表",
    type: "sizeSet",
    defaultValue: {
      widthVal: 500,
      heightVal: 300,
      widthAuto: true,
      heightAuto: true,
      widthFull: false,
    },
    extraConfig: {
      hideWidth: true,
      heightTitle: '高度'
    }
  },
  {
    name: "wholeBackground",
    desc: "背景",
    isSystem: true,
    group: "默认",
    categoryName: "菜单列表",
    type: "backgroundSet",
    defaultValue: [
      {
        type: "color",
        color: "#fff",
        isThemeColor: false
      }
    ]
  },
  {
    name: "navBorder",
    desc: "边框",
    isSystem: true,
    group: "默认",
    type: "borderSet",
    categoryName: "菜单列表",
    defaultValue: {
      borderStyle: "solid",
      borderWidth: [0, 0, 0, 0],
      borderColor: "rgba(10, 107, 255, 1)"
    }
  },
  {
    name: "navPadding",
    desc: "边距",
    isSystem: true,
    group: "默认",
    type: "paddingSet",
    categoryName: "菜单列表",
    defaultValue: {
      ...defaultPaddingSetting,
      padding: 10
    }
  },
  {
    name: "navBorderRadius",
    desc: "圆角",
    isSystem: true,
    group: "默认",
    type: "radiusSet",
    categoryName: "菜单列表",
    defaultValue: {
      ...defaultBorderRadiusSetting
    }
  },
  {
    name: "navBoxShadow",
    desc: "阴影",
    isSystem: true,
    categoryName: "菜单列表",
    group: "默认",
    type: "shadowSet",
    defaultValue: {
      ...defaultBoxShadowSetting
    }
  },
  {
    name: "navGap",
    desc: "行间距",
    isSystem: true,
    group: "默认",
    categoryName: "菜单列表",
    type: "numberSet",
    defaultValue: 10,
    unit: 'px',
    extraConfig: {
      suffix: 'px'
    }
  },
  {
    name: "showConnector",
    desc: "显示连接符",
    isSystem: true,
    group: "默认",
    categoryName: "菜单列表",
    type: "booleanSet",
    defaultValue: false,
  },
  {
    name: "connectorColor",
    desc: "颜色",
    isSystem: true,
    group: "默认",
    categoryName: "菜单列表",
    type: "colorSet",
    defaultValue: {
      type: 'color',
      color: 'rgba(10, 107, 255, 1)',
      isThemeColor:true,
      data: {
        angle: 0,
        stops: [
          ['rgba(10, 107, 255, 1)', 0],
          ['rgba(10, 107, 255, 1)', 1]
        ]
      }
    },
  },
  {
    name: "connectorWidth",
    desc: "粗细",
    isSystem: true,
    group: "默认",
    categoryName: "菜单列表",
    type: "numberSet",
    defaultValue: 0,
    extraConfig: {
      suffix: 'px'
    },
    unit: 'px'
  },
]

export default props
